import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { Date, DateField, CheckboxField, Checkbox } from '@components/form';

const View: React.SFC<any> = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={12}>
          <DateField component={Date} id="reportedDate" name="reportedDate" label="Nahlášeno" />
        </Col>
      </Row>
      <Row>
        {[{ name: 'local', label: 'Místní pátrání' }, { name: 'found', label: 'Nalezeno' }].map(({ name, label }) => (
          <Col md={6} key={name}>
            <CheckboxField component={Checkbox} id={name} name={name} label={label} />
          </Col>
        ))}
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>
  </div>
);

export const WantedVehiclesFormSearch = View;



// WEBPACK FOOTER //
// ./src/modules/wantedVehicles/WantedVehiclesFormSearch.tsx